import { catchError } from 'rxjs/operators';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

const BASE_PATH = '/axonapi/selfreg';
export abstract class AbstractHttpService {
	constructor(private http: HttpClient) { }

	protected get<T>(uri: string): Observable<T> {
		return this.handleError(this.http.get<T>(`${BASE_PATH}${uri}`, { headers: this.authHeaders }));
	}
	protected getWithOtp<T>(uri: string, otp: string): Observable<T> {
		let headers = new HttpHeaders();
		headers = headers.append('otp', otp);
		return this.handleError(this.http.get<T>(`${BASE_PATH}${uri}`, { headers: headers }));
	}
	protected post<T>(uri: string, payload: any, parameters?: HttpParams): Observable<T> {
		if (parameters) {
			return this.handleError(this.http.post<T>(`${BASE_PATH}${uri}`, payload, { params: parameters, headers: this.authHeaders }));
		}
		return this.handleError(this.http.post<T>(`${BASE_PATH}${uri}`, payload, { headers: this.authHeaders }));
	}
	protected postWithOtp<T>(uri: string, payload: any, otp: string): Observable<T> {
		let headers = new HttpHeaders();
		headers = headers.append('otp', otp);
		return this.handleError(this.http.post<T>(`${BASE_PATH}${uri}`, payload, { headers: headers }));
	}
	protected doUploadFile(uri: string, payload: any): Observable<HttpEvent<object>> {
		return this.handleError(this.http.post(`${BASE_PATH}${uri}`, payload, {
			reportProgress: true,
			observe: 'events',
			headers: this.authHeaders
		}));
	}
	protected doDownloadFile(uri: string): Observable<HttpEvent<Blob>> {
		return this.handleError(this.http.get(`${BASE_PATH}${uri}`, {
			responseType: 'blob',
			reportProgress: true,
			observe: 'events',
			headers: this.authHeaders
		}));
	}
	protected doDownloadFileSimple(uri: string): Observable<Blob> {
		return this.handleError(this.http.get(`${BASE_PATH}${uri}`, { responseType: 'blob', headers: this.authHeaders }));
	}
	protected delete(uri: string): Observable<any> {
		return this.handleError(this.http.delete(`${BASE_PATH}${uri}`, { headers: this.authHeaders }));
	}
	public getPathPrefix(): string {
		return BASE_PATH;
	}
	private get authHeaders(): HttpHeaders {
		const headers = new HttpHeaders();
		// if (this.dataStoreService.authToken) {
		// 	return headers.append('AUTH-CODE', this.dataStoreService.authToken);
		// }
		return headers;
	}

	private handleError<T>(input: Observable<T>): Observable<T> {
		return input.pipe(catchError((item: HttpErrorResponse) => {
			// if (item.status === 401) {
			// 	this.router.navigate(['/capture-msisdn']);
			// }
			throw item;
		}));
	}
}